import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as DOMPurify from 'dompurify';

@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {

  constructor(protected domSanitizer: DomSanitizer) {}

  transform(value: any, args?: any): any {
    const sanitisedValue = DOMPurify.sanitize(value);
    return this.domSanitizer.bypassSecurityTrustHtml(sanitisedValue);
  }

}
